// import React, { useState, useEffect } from "react";
// import { Spin, message } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
// import { LoadingOutlined } from "@ant-design/icons";

// const BarGraph = (props) => {
//   const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
//   const config = {
//     type: "serial",
//     backgroundColor: "#2F3640",
//     backgroundAlpha: 1,
//     addClassNames: true,
//     theme: "none",
//     autoMargins: false,
//     marginLeft: 55,
//     marginRight: 20,
//     marginTop: 10,
//     marginBottom: 70,
//     balloon: {
//       adjustBorderColor: false,
//       horizontalPadding: 10,
//       verticalPadding: 8,
//       color: "#ffffff",
//     },

//     dataProvider: props.data,
//     color: "#7f7f7f",
//     titleColor: "#7f7f7f",
//     valueAxes: [
//       {
//         axisAlpha: 0,
//         position: "left",
//         color: "#7f7f7f",
//       },
//     ],
//     startDuration: 1,
//     graphs: [
//       {
//         lineAlpha: 0.6,
//         alphaField: "alpha",
//         fillColors: "#FFE600",
//         lineColor: "#FFE600",
//         balloonText:
//           "<span style='font-size:12px;color:#4d83ff'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span> [[additional]]</span>",
//         fillAlphas: 1,
//         title: "Actual",
//         type: "column",
//         valueField: props.barkey ? props.barkey : "actual",
//         dashLengthField: "dashLengthColumn",
//       },
//       {
//         id: "graph2",
//         balloonText:
//           "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span> [[additional]]</span>",
//         bullet: "round",
//         lineThickness: 3,
//         bulletSize: 7,
//         bulletBorderAlpha: 1,
//         bulletColor: "#03A9F4",
//         lineColor: "#03A9F4",
//         useLineColorForBulletBorder: true,
//         bulletBorderThickness: 3,
//         fillAlphas: 0,
//         lineAlpha: 1,
//         title: "Tgt",
//         valueField: props.xkey ? props.xkey : "tgt",
//         dashLengthField: "dashLengthLine",
//       },
//     ],
//     categoryField: "time",
//     categoryAxis: {
//       gridPosition: "start",
//       axisAlpha: 0,
//       labelRotation: -45,
//       centerRotatedLabels: true,
//       tickLength: 0,
//     },
//     export: {
//       enabled: false,
//     },
//   };

//   return (
//     <div style={{ padding: "10px" }}>
//       {props.data ? (
//         <AmCharts.React
//           style={{ width: "100%", height: "330px" }}
//           options={config}
//         />
//       ) : (
//         <div className="Loading">
//           <Spin indicator={antIcon} tip="Loading..." />
//         </div>
//       )}
//     </div>
//   );
// };

// export default BarGraph;

import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const BarGraph = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);

  useLayoutEffect(() => {
    let x = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.XYChart
    );
    x.background.fill = "#2F3640";
    x.background.opacity = 0.5;
    x.legend = new am4charts.Legend();
    x.legend.labels.template.fill = am4core.color("#fff");

    if (props.data) {
      // x.dateFormatter.inputDateFormat = "yyyy-MM-dd";
      x.data = props.data;

      //title
      var title = x.titles.create();
      title.text = props.title;
      // title.text = "Performance Trend";
      title.fontSize = 25;
      title.marginBottom = 30;
      title.align = "center";
      title.fontWeight = 600;
      title.fill = "#b1b0b5";

      // Create axes
      // var dateAxis = x.xAxes.push(new am4charts.DateAxis());
      var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.labels.template.fontSize = 11;
      valueAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      valueAxis.renderer.line.strokeOpacity = 0.2;
      valueAxis.renderer.line.strokeWidth = 1;
      valueAxis.renderer.line.stroke = am4core.color("#000");
      // valueAxis.title.text = "Actual";

      /* Create axes */
      var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = props.category
        ? props.category
        : "time";
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.labels.template.fontSize = 11;
      categoryAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.line.stroke = am4core.color("#000");
      categoryAxis.renderer.labels.template.rotation = 45;
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.horizontalCenter = "left";

      /* Create series */
      let columnSeries = x.series.push(new am4charts.ColumnSeries());
      // columnSeries.name = "actual";
      columnSeries.yAxis = valueAxis;
      columnSeries.dataFields.valueY = props.barkey ? props.barkey : "actual";
      columnSeries.dataFields.categoryX = props.category
        ? props.category
        : "time";
      columnSeries.name = props.actLabel ? props.actLabel : "Actual";
      columnSeries.fontWeight = "600";
      // columnSeries.columns.template.width = am4core.percent(40);

      columnSeries.columns.template.tooltipText =
        "{categoryX}: [bold]{valueY}[/]";
      columnSeries.columns.template.fillOpacity = 0.8;
      columnSeries.columns.template.strokeOpacity = 0;
      columnSeries.columns.template.fill = props.barColor
        ? am4core.color(props.barColor)
        : "color";
      columnSeries.columns.template.fontSize = 11;
      columnSeries.columns.realStroke = props.barColor
        ? am4core.color(props.barColor)
        : "color";

      /* Create line series */
      let lineSeries = x.series.push(new am4charts.LineSeries());
      lineSeries.dataFields.valueY = props.xkey ? props.xkey : "tgt";
      lineSeries.dataFields.categoryX = props.category
        ? props.category
        : "time";
      lineSeries.name = props.tgtLabel ? props.tgtLabel : "Target";
      lineSeries.fontWeight = "600";
      lineSeries.tooltipText = "{categoryX}: [bold]{valueY}[/]";
      lineSeries.strokeWidth = 3;
      lineSeries.yAxis = valueAxis;
      lineSeries.bullets.push(new am4charts.CircleBullet());

      // columnSeries.columns.template.column.cornerRadiusTopLeft = 10;
      // columnSeries.columns.template.column.cornerRadiusTopRight = 10;

      // columnSeries.columns.template.column.cornerRadiusBottomLeft = 10;
      // columnSeries.columns.template.column.cornerRadiusBottomRight = 10;

      // var shadow = columnSeries.filters.push(new am4core.DropShadowFilter());
      // shadow.dx = 20;
      // shadow.dy = 20;
      // shadow.blur = 5;

      // x.background.fill = am4core.color("#2F3640");

      chart.current = x;
    }

    return () => {
      x.dispose();
    };
  }, [props.data]);

  return (
    <div>
      {/* <div id={(props.divId) ? props.divId : "DivID"} style={{ width: "100%", height: "330px" }}></div> */}
      {/* {props.data ? ( */}
      <div
        id={props.divId ? props.divId : "DivID"}
        style={{ width: props.width ? props.width : "100%", height: "450px" }}
      ></div>
      {/* ) : (
        <div className="Loading">
          <Spin indicator={antIcon} />
        </div>
      )} */}
    </div>
  );
};

export default BarGraph;
